import { render, staticRenderFns } from "./grasping_rules_stores.vue?vue&type=template&id=01a38123&scoped=true"
import script from "./grasping_rules_stores.vue?vue&type=script&lang=js"
export * from "./grasping_rules_stores.vue?vue&type=script&lang=js"
import style0 from "./grasping_rules_stores.vue?vue&type=style&index=0&id=01a38123&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a38123",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a38123')) {
      api.createRecord('01a38123', component.options)
    } else {
      api.reload('01a38123', component.options)
    }
    module.hot.accept("./grasping_rules_stores.vue?vue&type=template&id=01a38123&scoped=true", function () {
      api.rerender('01a38123', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/kms_new/views/order_display/document_display/form/components/grasping_rules_stores.vue"
export default component.exports